const recipes = [
  {
    id: 'tortilla-del-marco',
    name: 'Tortilla del Marco',
    category: 'Grains',
    baseYield: 18,
    defaultBase: 'AP Flour',
    ingredients: [
      { name: 'AP Flour', grams: 675, volumeUnit: 'cups', gramsPerUnit: 125 },
      { name: 'Baking Powder', grams: 11, volumeUnit: 'tsp', gramsPerUnit: 4.6 },
      { name: 'Salt', grams: 15, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'Melted Beef Tallow', grams: 158, volumeUnit: 'cups', gramsPerUnit: 205 },
      { name: 'Water', grams: 450, volumeUnit: 'cups', gramsPerUnit: 237 },
    ],
    instructions: [],
  },
  {
    id: 'fragos-hearty-pancakes',
    name: 'Fragos Hearty Pancakes',
    category: 'Grains',
    baseYield: 32,
    defaultBase: 'AP Flour',
    images: ['/recipes/fragos-hearty-pancakes-cover.jpg', '/recipes/fragos-hearty-pancakes-stack.jpg'],
    ingredients: [
      { name: 'AP Flour', grams: 480, volumeUnit: 'cups', gramsPerUnit: 125 },
      { name: 'Heavy W. Cream', grams: 747, volumeUnit: 'cups', gramsPerUnit: 237 },
      { name: 'Melted Butter', grams: 115, volumeUnit: 'cups', gramsPerUnit: 227 },
      { name: 'Salt', grams: 9, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'Eggs', grams: 299, volumeUnit: 'large eggs', gramsPerUnit: 50, showEggCount: true },
      { name: 'Sugar', grams: 67, volumeUnit: 'tbsp', gramsPerUnit: 12.5 },
      { name: 'Baking Powder', grams: 21, volumeUnit: 'tsp', gramsPerUnit: 4.6 },
    ],
    instructions: [
      'Beat the eggs and cream until light and foamy, about 3 minutes at high speed using a stand or hand mixer.',
      'Stir in the melted butter.',
      'Whisk the dry ingredients together (flour, salt, baking powder, sugar) to evenly distribute.',
      'Gently and quickly fold the dry mix into the egg and cream mixture. Do not overmix.',
      'Let the batter rest for at least 15 minutes while the griddle heats. It will thicken slightly.',
      'Heat a heavy frying pan over medium heat, or set an electric griddle to 375\u00B0F. Lightly grease the surface. The pan is ready when a drop of water skitters across and evaporates immediately.',
      'Drop 1/4 cup portions of batter onto the griddle.',
      'Cook until bubbles form and break on the surface, about 2 minutes. Flip once and cook the other side until golden, about 1.5 to 2 minutes. Only flip once.',
      'Serve immediately.',
    ],
  },
  {
    id: 'papa-fragos-secret-chocolate-chip-cookie',
    name: 'Papa Fragos Secret Chocolate Chip Cookie',
    category: 'Desserts',
    baseYield: 28,
    defaultBase: 'Bread Flour',
    note: '120g per cookie',
    images: ['/recipes/papa-fragos-secret-chocolate-chip-cookie-cover.jpg'],
    ingredients: [
      { name: 'Bread Flour', grams: 1198, volumeUnit: 'cups', gramsPerUnit: 127 },
      { name: 'Baking Soda', grams: 9, volumeUnit: 'tsp', gramsPerUnit: 4.6 },
      { name: 'Baking Powder', grams: 9, volumeUnit: 'tsp', gramsPerUnit: 4.6 },
      { name: 'Salt', grams: 16, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'Butter (unsalted)', grams: 703, volumeUnit: 'cups', gramsPerUnit: 227 },
      { name: 'Light Brown Sugar', grams: 622, volumeUnit: 'cups', gramsPerUnit: 220 },
      { name: 'Granulated Sugar', grams: 451, volumeUnit: 'cups', gramsPerUnit: 200 },
      { name: 'Large Eggs', grams: 373, volumeUnit: 'large eggs', gramsPerUnit: 50, showEggCount: true },
      { name: 'Pure Vanilla Extract', grams: 31, volumeUnit: 'tbsp', gramsPerUnit: 13 },
      { name: 'Bitter Sweet Chips', grams: 451, volumeUnit: 'cups', gramsPerUnit: 170 },
      { name: 'Semi Sweet Chocolate', grams: 451, volumeUnit: 'cups', gramsPerUnit: 170 },
    ],
    instructions: [
      'Whisk together the bread flour, baking powder, baking soda, and salt in a large bowl. Set aside.',
      'In a stand mixer with the paddle attachment, beat cold butter on medium speed until it starts to break apart, about 30 seconds. The goal is to smear the butter, not cream it.',
      'Add the brown sugar and granulated sugar. Mix just until incorporated but still crumbly.',
      'Add the eggs and vanilla. Mix on medium-low until the mixture looks slightly separated, about 30 seconds.',
      'Turn off the mixer. Add the dry ingredients and mix on low just until the dough comes together. Some streaks of butter may still be visible.',
      'Fold in the bitter sweet chips and semi sweet chocolate by hand using a rubber spatula.',
      'Drop dough into heaping mounds, about 120g per ball, onto parchment-lined sheet trays. Do not use a scoop \u2014 the roughness gives them character. Divide dough evenly to get your target yield.',
      'Place trays in the freezer for 1 hour.',
      'Preheat oven to 375\u00B0F. Rack in the middle position.',
      'Bake one tray at a time directly from freezer, 19\u201322 minutes, rotating the tray halfway through. Cookies should be slightly underbaked in the center but golden brown at the edges.',
      'Remove from oven and smack the tray on the counter. Cool on the tray for 5 minutes, then transfer to a wire rack to cool completely.',
    ],
  },
  {
    id: 'chicken-ala-fragos',
    name: 'Chicken Ala Fragos',
    category: 'Mains',
    baseYield: 6,
    defaultBase: 'Chicken (whole)',
    servingNote: 'Serve chicken and gravy over rice with vegetables on the side. Also serve with heated flour tortillas with butter.',
    ingredientSections: [
      {
        title: 'Chicken & Gravy',
        ingredients: [
          { name: 'Chicken (whole)', grams: 1200, volumeUnit: 'lbs', gramsPerUnit: 454 },
          { name: 'Butter (unsalted)', grams: 57, volumeUnit: 'tbsp', gramsPerUnit: 14 },
          { name: 'Flour', grams: 30, volumeUnit: 'tbsp', gramsPerUnit: 8 },
          { name: 'Chicken Broth', grams: 710, volumeUnit: 'cups', gramsPerUnit: 237 },
          { name: 'Heavy Cream', grams: 80, volumeUnit: 'tbsp', gramsPerUnit: 15 },
          { name: 'Salt', grams: 24, volumeUnit: 'tsp', gramsPerUnit: 6, note: '2% of chicken weight' },
          { name: 'Black Pepper', grams: 1.5, volumeUnit: 'tsp', gramsPerUnit: 2.3 },
          { name: 'Ground Cumin', grams: 0.3, volumeUnit: 'tsp', gramsPerUnit: 2.1 },
          { name: 'Thyme', grams: 0.7, volumeUnit: 'tsp', gramsPerUnit: 1 },
          { name: 'Chili Powder', grams: 1.5, volumeUnit: 'tsp', gramsPerUnit: 2.6 },
          { name: 'Oregano', grams: 0.7, volumeUnit: 'tsp', gramsPerUnit: 1.5 },
        ],
      },
      {
        title: 'Rice',
        ingredients: [
          { name: 'Chicken Broth', grams: 710, volumeUnit: 'cups', gramsPerUnit: 237 },
          { name: 'Salt', grams: 3, volumeUnit: 'tsp', gramsPerUnit: 6 },
          { name: 'Black Pepper', grams: 0.7, volumeUnit: 'tsp', gramsPerUnit: 2.3 },
          { name: 'Olive Oil', grams: 27, volumeUnit: 'tbsp', gramsPerUnit: 14 },
          { name: 'Dried Dill Weed', grams: 0.3, volumeUnit: 'tsp', gramsPerUnit: 1 },
          { name: 'Dried Chives', grams: 1.5, volumeUnit: 'tsp', gramsPerUnit: 0.5 },
          { name: 'Fresh Lemon Juice', grams: 10, volumeUnit: 'tsp', gramsPerUnit: 5 },
          { name: 'Rice', grams: 285, volumeUnit: 'cups', gramsPerUnit: 185 },
        ],
      },
      {
        title: 'Vegetables',
        ingredients: [
          { name: 'Frozen Mixed Vegetables', grams: 0, asNeeded: true },
          { name: 'Butter', grams: 14, volumeUnit: 'tbsp', gramsPerUnit: 14 },
          { name: 'Chicken Broth', grams: 150, volumeUnit: 'cups', gramsPerUnit: 237, rangeDisplay: '120\u2013180' },
        ],
      },
    ],
    instructionSections: [
      {
        title: 'Day 1',
        steps: [
          'Boil the chicken whole. Cool and separate the broth from the chicken.',
          'Debone and skin the chicken. Cut into bite-size pieces.',
          'Place chicken and broth in separate containers and refrigerate until the next day.',
        ],
      },
      {
        title: 'Day 2 \u2014 Chicken & Gravy',
        steps: [
          'Melt butter in a large pan.',
          'Whisk in the flour to make a roux.',
          'Gradually and very slowly add broth to the flour, stirring constantly with a whisk to prevent lumps in the gravy.',
          'Add the heavy cream to the broth mixture. Stir and simmer for 1 minute.',
          'Add all spices, stir, then add the chicken pieces. Heat for at least 15 minutes.',
        ],
      },
      {
        title: 'Rice',
        steps: [
          'Bring 3 cups chicken broth to a boil in a pan.',
          'Add salt, pepper, olive oil, dried dill weed, dried chives, and fresh squeezed lemon juice.',
          'When broth is boiling, add the rice. Simmer 20\u201325 minutes or until broth is absorbed.',
        ],
      },
      {
        title: 'Vegetables',
        steps: [
          'Steam frozen mixed vegetables in butter and chicken broth.',
        ],
      },
    ],
  },
  {
    id: 'frago-o-matic-bacon-cure',
    name: 'Frago-O-Matic Bacon Cure',
    category: 'Charts',
    type: 'calculator',
    baseLabel: 'Pork Belly',
    calculations: [
      { name: 'Salt', rate: 0.015 },
      { name: 'Prague Powder #1', rate: 0.0025 },
    ],
    instructions: [],
  },
  {
    id: 'fragos-buffalo-sauce',
    name: 'Fragos Buffalo Sauce',
    category: 'Sauces',
    baseYield: 1,
    defaultBase: "Frank's Hot Sauce",
    ingredients: [
      { name: "Frank's Hot Sauce", grams: 60, volumeUnit: 'cup', gramsPerUnit: 240 },
      { name: 'Butter (unsalted)', grams: 17, volumeUnit: 'tbsp', gramsPerUnit: 14 },
      { name: 'Chicken Stock', grams: 240, volumeUnit: 'cup', gramsPerUnit: 240, note: 'starting amount — reduce to a glaze before building sauce' },
    ],
    instructions: [
      'Pour chicken stock into a saucepan over medium-high heat.',
      'Reduce until syrupy and sticky — most of the water should be cooked off. This is your flavor base.',
      "Lower heat to medium. Pour in Frank's hot sauce and whisk to combine with the reduction.",
      'Add butter and whisk continuously until fully melted and emulsified into the sauce.',
      'Serve immediately — this is an emulsion and does not store well.',
    ],
  },
  {
    id: 'fragos-liege-waffles',
    name: 'Liège Waffles ala Fragos',
    category: 'Grains',
    baseYield: 10,
    defaultBase: 'Bread flour',
    note: 'Authentic Belgian yeast-raised waffles with caramelized pearl sugar. The dough is brioche-like, not batter — sticky and rich. Pearl sugar is non-negotiable; granulated sugar will dissolve and burn. Eat warm and plain — the caramelized sugar crust is the entire flavor.',
    servingNote: 'Makes 10 waffles (~100g dough balls)',
    images: [
      '/recipes/fragos-liege-waffles-cover.jpg',
      '/recipes/fragos-liege-waffles-sugar.jpg',
      '/recipes/fragos-liege-waffles-served.jpg',
    ],
    ingredients: [
      { name: 'Bread flour', grams: 220, volumeUnit: 'cup', gramsPerUnit: 125 },
      { name: 'Instant yeast', grams: 6, volumeUnit: 'tsp', gramsPerUnit: 3 },
      { name: 'Heavy whipping cream, warmed to 110°F', grams: 23, volumeUnit: 'tbsp', gramsPerUnit: 15 },
      { name: 'Warm water (110°F)', grams: 30, volumeUnit: 'tbsp', gramsPerUnit: 15 },
      { name: 'Large eggs, room temperature', grams: 100, volumeUnit: 'large eggs', gramsPerUnit: 50, showEggCount: true },
      { name: 'Light brown sugar', grams: 18, volumeUnit: 'tbsp', gramsPerUnit: 12 },
      { name: 'Vanilla extract', grams: 4, volumeUnit: 'tsp', gramsPerUnit: 4 },
      { name: 'Salt', grams: 3, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'Unsalted butter, softened', grams: 225, volumeUnit: 'cup', gramsPerUnit: 225 },
      { name: 'Belgian pearl sugar', grams: 200, volumeUnit: 'cup', gramsPerUnit: 200, note: 'Non-negotiable — no substitutes. Granulated sugar will dissolve.' },
    ],
    instructions: [
      'Bloom yeast: combine warm cream, warm water, and brown sugar in a small bowl. Sprinkle yeast on top. Let stand 10–15 minutes until foamy.',
      'In stand mixer with dough hook, combine bread flour and salt. Add the yeast mixture, eggs, and vanilla. Knead on low 4–5 minutes until a shaggy dough forms.',
      'Add softened butter 1 tablespoon at a time, kneading until each addition is fully absorbed before adding the next. Total kneading is 8–10 minutes. Dough will be very sticky — this is correct.',
      'Cover bowl with plastic wrap. Let rise at room temperature until doubled, 60–90 minutes.',
      'Punch down the dough and fold in pearl sugar by hand. Do not overwork — sugar pearls should remain whole and intact.',
      'Divide dough into 10 equal balls (~100g each). Cover and rest 15 minutes.',
      'Preheat waffle iron to 365°F. Cook each ball 2–3 minutes until deeply golden-brown and the sugar has caramelized on the surface. Eat immediately.',
    ],
  },
  {
    id: 'fragos-brussels-waffles',
    name: 'Brussels Waffles ala Fragos',
    category: 'Grains',
    baseYield: 8,
    defaultBase: 'AP Flour',
    note: 'Light, crisp Belgian waffles with deep pockets — yeast-raised batter with whipped egg whites folded in for an airy interior and shatteringly crisp shell. Different beast from Liège: no pearl sugar, no caramelization. Brussels waffles are not sweet themselves — sweetness comes from the powdered sugar, whipped cream, or fruit on top. Eat within minutes of cooking; they go soft fast.',
    servingNote: 'Makes 8 large waffles',
    ingredients: [
      { name: 'AP Flour', grams: 250, volumeUnit: 'cups', gramsPerUnit: 125 },
      { name: 'Whole milk, warmed to 110°F', grams: 415, volumeUnit: 'cups', gramsPerUnit: 240 },
      { name: 'Unsalted butter, melted and cooled', grams: 115, volumeUnit: 'cups', gramsPerUnit: 227 },
      { name: 'Large eggs, separated', grams: 150, volumeUnit: 'large eggs', gramsPerUnit: 50, showEggCount: true },
      { name: 'Instant yeast', grams: 6, volumeUnit: 'tsp', gramsPerUnit: 3 },
      { name: 'Granulated sugar', grams: 12, volumeUnit: 'tbsp', gramsPerUnit: 12 },
      { name: 'Vanilla extract', grams: 4, volumeUnit: 'tsp', gramsPerUnit: 4 },
      { name: 'Salt', grams: 3, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'White vinegar', grams: 1, volumeUnit: 'tsp', gramsPerUnit: 5, note: 'Stabilizes whipped egg whites — substitutes for cream of tartar.' },
      { name: 'Powdered sugar, for serving', grams: 0, asNeeded: true },
    ],
    instructions: [
      'Bloom yeast: warm milk to 110°F. Whisk in yeast and granulated sugar. Let stand 10 minutes until foamy.',
      'In a large bowl, whisk flour and salt. Make a well in the center.',
      'Pour the milk/yeast mixture, melted butter, egg yolks, and vanilla into the well. Whisk until smooth. Batter will be thick — slightly thicker than pancake batter.',
      'Cover with plastic wrap. Let rise at room temperature for 1 hour until bubbly and roughly doubled.',
      'Just before cooking, whip the egg whites with white vinegar to stiff peaks in a clean bowl.',
      'Gently fold the whipped whites into the risen batter. Preserve as much air as possible — streaks of white are fine. Do not overmix.',
      'Preheat waffle iron to 375°F. Cook each waffle 3–4 minutes until deeply golden and crisp.',
      'Serve immediately, dusted with powdered sugar. Optional: whipped cream, fresh strawberries, or warm berry compote.',
    ],
  },
  {
    id: 'fragos-jerky',
    name: 'Fragos Jerky',
    category: 'Charts',
    type: 'calculator',
    baseLabel: 'Beef',
    calculations: [
      { name: 'Salt', rate: 0.02 },
      { name: 'Prague Powder #1', rate: 0.0025 },
    ],
    instructions: [
      'Slice beef ¼" thick against the grain (or with the grain for chewier jerky). Use lean cuts: eye of round, top round, or flank.',
      'Weigh the sliced beef in grams. Enter weight above to calculate salt and cure amounts.',
      'Mix salt and Prague Powder #1 thoroughly with the sliced beef in a zip-top bag or non-reactive container. Massage to coat evenly.',
      'Refrigerate 12–24 hours. Longer cure = deeper color and flavor.',
      'Smoke at 165°F until internal temperature hits 150°F and holds for at least 30 minutes (this is the kill step — do not skip).',
      'Continue smoking/dehydrating until jerky is pliable but dry. Bend test: should crack but not snap.',
      'Cool fully at room temperature before packaging.',
      'Vacuum-seal or store in airtight container. Room-temp storage safe for ~4 weeks given the 2% salt + Cure #1 + cooked process. Refrigerate or freeze for longer storage.',
    ],
  },
  {
    id: 'fragos-buttermilk-biscuits',
    name: 'Fragos Buttermilk Biscuits',
    category: 'Grains',
    baseYield: 8,
    defaultBase: 'AP Flour',
    note: 'Tall, flaky, golden pull-apart layers — Pillsbury Grands height with real ingredients and gourmet flavor. The 4-fold lamination creates the layers; frozen grated butter creates the steam pockets; beef tallow adds savory depth; chicken stock + heavy cream + vinegar makes a richer-than-buttermilk soured liquid. Full-fat everything, cold everything, no twisting the cutter, sides just barely touching on the pan. Eat warm — best in the first 30 minutes out of the oven.',
    servingNote: 'Makes 8 large biscuits',
    ingredients: [
      { name: 'AP Flour', grams: 360, volumeUnit: 'cups', gramsPerUnit: 125, note: 'White Lily preferred for softer Southern crumb. Standard AP works fine.' },
      { name: 'Baking powder', grams: 12, volumeUnit: 'tsp', gramsPerUnit: 4.6 },
      { name: 'Baking soda', grams: 3, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'Fine sea salt', grams: 6, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'Granulated sugar', grams: 12, volumeUnit: 'tbsp', gramsPerUnit: 12 },
      { name: 'Unsalted butter, frozen and grated', grams: 170, volumeUnit: 'cups', gramsPerUnit: 227 },
      { name: 'Beef tallow, cold and cubed', grams: 45, volumeUnit: 'cups', gramsPerUnit: 205 },
      { name: 'Heavy whipping cream, cold', grams: 200, volumeUnit: 'cups', gramsPerUnit: 240 },
      { name: 'Chicken stock, cold', grams: 100, volumeUnit: 'cups', gramsPerUnit: 240 },
      { name: 'White distilled vinegar', grams: 15, volumeUnit: 'tbsp', gramsPerUnit: 15 },
      { name: 'Unsalted butter, melted (for brushing)', grams: 30, volumeUnit: 'tbsp', gramsPerUnit: 14 },
      { name: 'Flaky sea salt, for finishing', grams: 0, asNeeded: true },
    ],
    instructions: [
      'At least 1 hour before mixing: freeze the 170g block of unsalted butter solid. Once frozen, grate on the large holes of a box grater into a small bowl. Return grated butter to the freezer until use.',
      'Combine the cold heavy cream, cold chicken stock, and white distilled vinegar in a measuring cup. Whisk briefly and let stand 5–10 minutes until slightly thickened — this is your DIY buttermilk. Keep cold.',
      'Preheat oven to 425°F. Line a half sheet pan with parchment.',
      'In a large bowl, whisk flour, baking powder, baking soda, salt, and sugar until evenly combined.',
      'Add the frozen grated butter and cold cubed beef tallow to the dry ingredients. Toss gently with fingertips to coat each piece in flour. Do NOT rub or cut in — you want the fat to stay in distinct pieces.',
      'Pour in the cold soured liquid all at once. Stir with a fork just until a shaggy dough forms — there should still be dry patches and visible fat chunks. Stop the moment it comes together.',
      'Turn dough onto a floured surface. Pat (do not roll) into a 1" thick rectangle. Fold like a letter — left third over middle, right third over. Rotate 90°, pat back to 1" thick, fold again. Repeat for 4 total folds. Dough will go from shaggy to smooth and visibly layered.',
      'Pat the final dough into a 1.25" thick rectangle. Cut with a sharp 3" round cutter — straight down, no twisting (twisting seals the layers and prevents rise). Square biscuits cut with a bench knife are also fine, no scraps wasted.',
      'Place biscuits on the parchment-lined sheet pan with sides just barely touching — this forces vertical rise instead of spreading.',
      'Brush tops generously with melted butter. Sprinkle with flaky sea salt if using.',
      'Bake at 425°F for 18–22 minutes until tops are deeply golden brown and the sides have pulled away. Internal temperature should hit 200°F.',
      'Brush with more melted butter immediately out of the oven. Serve warm.',
    ],
  },
  {
    id: 'fragos-brioche-burger-buns',
    name: 'Fragos Brioche Burger Buns',
    category: 'Grains',
    baseYield: 8,
    defaultBase: 'King Arthur bread flour',
    note: 'Monduras v1.2 (hydration corrected from v1.1 — 75g water added; ~55% effective hydration, fat unchanged at ~30%). Premium restaurant-quality burger bun built for smash burgers — buttery, soft, rich, and sturdy enough to hold a juicy burger without falling apart. Heavy cream is the only dairy; no milk or buttermilk. Timing: 30 min prep, 12–18 hr cold fermentation, 1½–2½ hr final proof, 13–15 min bake (~16 hr total).',
    servingNote: 'Makes 8 buns (~126g dough balls)',
    images: [
      '/recipes/fragos-brioche-burger-buns-cover.jpg',
      '/recipes/fragos-brioche-burger-buns-batch.jpg',
      '/recipes/fragos-brioche-burger-buns-burger.jpg',
    ],
    ingredientSections: [
      {
        title: 'Dough',
        ingredients: [
          { name: 'King Arthur bread flour', grams: 500, volumeUnit: 'cup', gramsPerUnit: 125 },
          { name: 'Heavy cream', grams: 220, volumeUnit: 'cup', gramsPerUnit: 238 },
          { name: 'Water', grams: 75, volumeUnit: 'cup', gramsPerUnit: 237 },
          { name: 'Large eggs, room temperature', grams: 100, volumeUnit: 'large eggs', gramsPerUnit: 50, showEggCount: true },
          { name: 'Unsalted butter (Plugrá preferred), softened', grams: 60, volumeUnit: 'tbsp', gramsPerUnit: 14 },
          { name: 'Granulated sugar', grams: 35, volumeUnit: 'tbsp', gramsPerUnit: 12.5 },
          { name: 'Fine sea salt', grams: 10, volumeUnit: 'tsp', gramsPerUnit: 6 },
          { name: 'Instant yeast', grams: 7, volumeUnit: 'tsp', gramsPerUnit: 3 },
        ],
      },
      {
        title: 'Egg Wash (does not scale — covers 4–16 buns)',
        ingredients: [
          { name: '1 large egg', asNeeded: true },
          { name: '15 g (1 tbsp) heavy cream', asNeeded: true },
          { name: 'Pinch of fine salt', asNeeded: true },
        ],
      },
      {
        title: 'Finishing',
        ingredients: [
          { name: 'Melted butter for brushing after baking', asNeeded: true },
        ],
      },
    ],
    instructionSections: [
      {
        title: 'Day 1',
        steps: [
          'Combine the bread flour, instant yeast, sugar, and salt in the bowl of a stand mixer.',
          'Add the heavy cream, water, and eggs.',
          'Mix on low speed until a shaggy dough forms.',
          'Knead for approximately 5 minutes until gluten begins developing.',
          'Add the softened butter a little at a time while mixing.',
          'Continue kneading on low speed until the dough is smooth, satiny, elastic, and nearly passes the windowpane test. Total mixing time after adding butter is typically 8–10 minutes.',
          'Form the dough into a smooth ball and place into a lightly buttered bowl.',
          'Cover tightly and refrigerate for 12–18 hours.',
        ],
      },
      {
        title: 'Next Day',
        steps: [
          'Remove dough from the refrigerator and allow it to warm for 45–60 minutes.',
          'Divide into 8 equal pieces (approximately 125–127 g each at base yield).',
          'Shape each piece into a tight ball using minimal flour on the work surface.',
          'Place on parchment-lined baking sheets.',
          'Gently flatten each ball to approximately 4 inches (10 cm) in diameter — this produces the proper burger bun shape rather than a dinner roll.',
          'Cover and proof until very puffy and slightly jiggly, approximately 1½–2½ hours depending on room temperature.',
          'Preheat oven to 375°F (190°C).',
          'Whisk together the egg, heavy cream, and pinch of salt. Brush each bun gently with the egg wash.',
          'Bake for 13–15 minutes until deep golden brown. Internal temperature should reach approximately 195°F (90°C).',
          'Immediately brush the hot buns with melted butter.',
          'Cool completely on a wire rack before slicing.',
        ],
      },
      {
        title: "Chef's Notes",
        steps: [
          'v1.2 dough is noticeably slacker and tackier than v1.1 — this is correct. Resist adding flour during kneading; use minimal flour only when shaping.',
          'Proper gluten development is more important than mixing by time. The dough should become smooth, satiny, and nearly pass a windowpane test.',
          'Overnight cold fermentation creates significantly better flavor and texture.',
          'Do not skip flattening before the final proof. This produces the classic wide hamburger bun profile.',
          'Bake only after the buns become noticeably puffy. A full final proof creates the soft, airy crumb expected from a premium burger bun.',
          'Toast the cut sides in butter or beef tallow before serving.',
        ],
      },
      {
        title: 'Storage',
        steps: [
          'Store in an airtight container for up to 3 days.',
          'Freezes exceptionally well for up to 3 months. Thaw at room temperature and toast before serving.',
        ],
      },
    ],
  },
  {
    id: 'fragos-taco-meat',
    name: 'Fragos Taco Meat',
    category: 'Mains',
    note: 'Fragos Taco Meat v1.2',
    baseYield: 1361,
    yieldLabel: 'Beef (g)',
    servingNote: '1361g raw beef (3 lbs) ≈ 5 servings — type your actual beef weight above',
    images: ['/recipes/fragos-taco-meat-cover.jpg'],
    defaultBase: 'Ground Beef 80/20',
    ingredientSections: [
      {
        title: 'Base',
        ingredients: [
          { name: 'Ground Beef 80/20', grams: 1361 },
          { name: 'Chicken Stock', grams: 480, volumeUnit: 'cups', gramsPerUnit: 240, note: 'Rich homemade, high-gelatin' },
          { name: 'Fish Sauce', grams: 6, volumeUnit: 'tsp', gramsPerUnit: 6 },
          { name: 'Reserved Beef Fat', grams: 51.2, volumeUnit: 'tbsp', gramsPerUnit: 12.8, note: 'Reserved from browning — already counted in the beef weight, not an addition.' },
        ],
      },
      {
        title: 'Spices',
        ingredients: [
          { name: 'Dark Chili Powder', grams: 31.2, volumeUnit: 'tbsp', gramsPerUnit: 7.8 },
          { name: 'Ground Cumin', grams: 18.9, volumeUnit: 'tbsp', gramsPerUnit: 6.3 },
          { name: 'Granulated Garlic', grams: 9.3, volumeUnit: 'tbsp', gramsPerUnit: 9.3 },
          { name: 'Granulated Onion', grams: 8.4, volumeUnit: 'tbsp', gramsPerUnit: 8.4 },
          { name: 'Salt', grams: 15, volumeUnit: 'tsp', gramsPerUnit: 6, note: 'Morton iodized table or coarse kosher — same by weight. Adjust to taste' },
          { name: 'Smoked Paprika', grams: 4.6, volumeUnit: 'tsp', gramsPerUnit: 2.3 },
          { name: 'Black Pepper', grams: 2.3, volumeUnit: 'tsp', gramsPerUnit: 2.3, note: 'Freshly ground' },
          { name: 'Cayenne Pepper', grams: 0.5 },
        ],
      },
      {
        title: 'Finish',
        ingredients: [
          { name: 'White Distilled Vinegar', grams: 7.5, volumeUnit: 'tbsp', gramsPerUnit: 15 },
          { name: 'Butter', grams: 14, volumeUnit: 'tbsp', gramsPerUnit: 14 },
          { name: 'Lime Juice', asNeeded: true, note: 'Juice of ½ lime, stirred in off heat at the end' },
        ],
      },
    ],
    instructionSections: [
      {
        title: 'Method',
        steps: [
          'Brown the ground beef. Drain all rendered fat, then return approximately 4 tbsp (51 g) to the pan.',
          'On low heat, add all dry spices and stir constantly for 30–45 seconds until fragrant. Do not let the chili powder scorch.',
          'Add the chicken stock and fish sauce, deglazing the pan, and bring to a gentle simmer.',
          'Simmer uncovered, stirring occasionally — reduce 15–20 minutes, until the sauce coats the meat.',
          'Taste and adjust salt if needed.',
          'Remove from heat. Stir in the vinegar, butter and lime juice — stir until the butter is melted and glossy.',
        ],
      },
      {
        title: "Chef's Notes",
        steps: [
          'The high-gelatin homemade stock creates a rich, silky texture without flour or cornstarch.',
          'Intentionally cumin-forward with moderate chili flavor and mild heat.',
          'Increase cayenne for more heat, or cut it to 0.2g for a milder batch.',
          "Salt sits at roughly 1.1% of raw beef weight, before the sodium already in the chili powder. The Baker's % column reads it directly if you adjust.",
        ],
      },
    ],
  },
  {
    id: 'fragos-sandwich-bread',
    name: 'Fragos Sandwich Bread',
    category: 'Grains',
    baseYield: 1,
    defaultBase: 'Bread Flour',
    note: 'Tangzhong white sandwich bread, sized for the Baker\'s Mark 13" x 4" x 4" Pullman pan, lid on. Baker\'s % reads against the 510g dough flour; total flour including the tangzhong is 540g.',
    servingNote: 'Makes one 13" Pullman loaf (~1,059g dough -> three ~353g logs)',
    images: [
      '/recipes/fragos-sandwich-bread-cover.jpg',
      '/recipes/fragos-sandwich-bread-crumb.jpg',
      '/recipes/fragos-sandwich-bread-grilled-cheese.jpg',
      '/recipes/fragos-sandwich-bread-proof.jpg',
    ],
    ingredientSections: [
      {
        title: 'Tangzhong',
        ingredients: [
          { name: 'Bread Flour (tangzhong)', grams: 30, volumeUnit: 'cup', gramsPerUnit: 125 },
          { name: 'Whole milk (tangzhong)', grams: 150, volumeUnit: 'cup', gramsPerUnit: 240 }
        ]
      },
      {
        title: 'Dough',
        ingredients: [
          { name: 'Bread Flour', grams: 510, volumeUnit: 'cup', gramsPerUnit: 125 },
          { name: 'Whole milk', grams: 250, volumeUnit: 'cup', gramsPerUnit: 240, note: 'lukewarm' },
          { name: 'Sugar', grams: 45, volumeUnit: 'tbsp', gramsPerUnit: 12.5 },
          { name: 'Instant yeast', grams: 8, volumeUnit: 'tsp', gramsPerUnit: 3 },
          { name: 'Fine sea salt', grams: 11, volumeUnit: 'tsp', gramsPerUnit: 6 },
          { name: 'Unsalted butter, softened', grams: 55, volumeUnit: 'tbsp', gramsPerUnit: 14 }
        ]
      }
    ],
    instructionSections: [
      {
        title: 'Tangzhong',
        steps: [
          'Whisk the flour and milk smooth in a small saucepan while still cold. Lumps form if the flour meets hot liquid.',
          'Medium heat, whisking constantly, 2 to 3 minutes. Done when the whisk leaves a line on the bottom that holds for a beat (~150F).',
          'Scrape into a bowl, plastic wrap pressed to the surface, cool to room temp. Spread thin on a plate to cool in 15 minutes instead of 40. Can be made a day ahead and refrigerated.'
        ]
      },
      {
        title: 'Dough',
        steps: [
          'Mixer with dough hook: flour, milk, sugar, yeast and the cooled tangzhong. Mix 2 minutes to a shaggy mass. Rest 20 minutes.',
          'Add salt. Knead medium-low 4 minutes.',
          'Add butter a chunk at a time. Knead 8 to 10 minutes until the dough clears the bowl sides and passes a windowpane. Tacky, not sticky.',
          'Bulk ferment in a greased bowl, covered, 60 to 90 minutes until doubled. Or overnight in the fridge for better flavor, pulled 1 hour before shaping.'
        ]
      },
      {
        title: 'Shape and Proof',
        steps: [
          'Turn out and divide into three equal pieces, ~353g each.',
          'Flatten each into a rectangle, letter-fold, roll tight into a cylinder.',
          'Seam-down in the greased pan, laid crosswise so each log runs across the 4" width, three in a row down the 13". Snug, not jammed. They fuse into one loaf during proof and bake.',
          'Final proof 60 to 75 minutes, lid off, until the dough crowns about 1/2" below the pan rim. It will look like too much dough. It is not. Under-proofing here is what produces a short, dense loaf with a gap under the lid.',
          'Slide the lid on.'
        ]
      },
      {
        title: 'Bake',
        steps: [
          '375F, lid on, 32 to 38 minutes.',
          'Pull the lid and check internal temp. 195 to 200F.',
          'Out of the pan immediately onto a rack. Butter the crust while hot for a soft crust; leave bare for crisp.',
          'Minimum 2 hours before slicing or the crumb gums up.'
        ]
      },
      {
        title: 'Chef\'s Notes',
        steps: [
          'Pan sizing rule: ~5.1g dough per cubic inch for a lidded Pullman, roughly 2.6g flour per cubic inch. A 9x4x4 wants ~375g flour, 13x4x4 wants ~540g, 16x4x4 wants ~665g. Most published loaf recipes are built for a 9x5 pan and come up half short in this one.',
          'Lid on gives square slices and a tight fine crumb. Lid off gives a domed top and a slightly more open crumb. Same dough, just proof to the rim instead.',
          'No milk in the house: water plus 65g butter, and drop the dough milk to 210g. Good loaf, cleaner wheat flavor, stales a half-day sooner. 25g nonfat dry milk powder in the dry ingredients recovers most of the difference.',
          'Skipping the tangzhong: 540g flour, 355g milk, everything else the same. The dough cannot hold 400g without the gel. Still excellent, just eat it faster.'
        ]
      }
    ]
  },
  {
    id: 'papa-fragos-pizza-dough',
    name: 'Papa Fragos Pizza Dough',
    category: 'Grains',
    baseYield: 5,
    defaultBase: 'Bread flour',
    note: 'Cold bulk-fermented dough for 12-inch pies — fermented as one mass, divided and balled on baking day. 58.5% hydration, 2.2% salt, 2% oil. Same-day option in the instructions if you cannot wait. Timing: 20 min mix, 24–72 hr cold bulk, 3–4 hr bench proof, 6–8 min bake. — v1.1',
    servingNote: 'Makes 5 dough balls (~318g each) for 12-inch pies',
    images: ['/recipes/papa-fragos-pizza-dough-cover.jpg'],
    ingredients: [
      { name: 'Bread flour', grams: 976, volumeUnit: 'cup', gramsPerUnit: 125 },
      { name: 'Water, cold', grams: 571, volumeUnit: 'cup', gramsPerUnit: 237 },
      { name: 'Fine sea salt', grams: 21.5, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'Instant yeast', grams: 2.6, volumeUnit: 'tsp', gramsPerUnit: 3, note: 'Goes in dry — no proofing, no warm water' },
      { name: 'Olive oil', grams: 19.5, volumeUnit: 'tbsp', gramsPerUnit: 13.5 },
      { name: 'Semolina or flour for the peel', asNeeded: true },
    ],
    instructionSections: [
      {
        title: 'Day 1 — Mix and Bulk',
        steps: [
          'Whisk the flour and instant yeast together dry.',
          'Add all the water. Mix with a spatula or dough whisk until no dry flour remains. Cover and rest 30 minutes.',
          'Add the salt and olive oil. Knead 8–10 minutes by hand, or 5–6 minutes on a stand mixer at speed 2, until smooth and the dough stretches thin without tearing immediately.',
          'Round into a ball and place in a lightly oiled lidded container. Mark the level.',
          'Bulk 45 minutes at room temperature, then refrigerate as one mass for 24–72 hours. Forty-eight hours is the sweet spot. It will roughly double and go slack and bubbly.',
        ],
      },
      {
        title: 'Baking Day',
        steps: [
          'Turn the dough onto a lightly floured counter — ease it out, do not punch it down.',
          'Divide into 5 pieces at approximately 318 g each.',
          'Round each piece tight: fold the edges to the center, flip seam-down, and drag in circles under a cupped hand until the surface is taut.',
          'Place the balls in oiled containers or on a floured tray with space between them. Cover.',
          'Bench proof 3–4 hours at room temperature, until puffy and passive — a poked finger leaves a slow-returning dent.',
          'Preheat a steel or stone on the top-third rack at maximum temperature (550°F) for 45–60 minutes. Switch on the broiler for the last 10 minutes if you have one.',
          'Open by hand: press from the center outward, leaving the outer inch untouched for the rim, then stretch over your knuckles. Never a rolling pin.',
          'Dress fast and light, launch, and bake 6–8 minutes until the rim is blistered and spotted.',
        ],
      },
      {
        title: 'Same-Day Option',
        steps: [
          'Increase the yeast to 6 g and use lukewarm water (~85°F) instead of cold.',
          'Mix and knead as above, then bulk 2 hours at room temperature until nearly doubled.',
          'Divide and ball, bench proof 1 hour, then bake. About 3½ hours start to finish.',
          'The crust will be paler and blander than the cold-fermented version.',
          'Middle ground if you have 8 hours: warm water, 3 g yeast, bulk 4 hours, ball, proof 2 hours.',
        ],
      },
      {
        title: "Chef's Notes",
        steps: [
          'Bulk fermenting as one mass gives a stronger, more extensible dough and one container instead of four. The trade is that the bench proof after dividing is not optional — the balls need 3–4 hours to relax or they will fight you when you open them.',
          'Cold water for the cold ferment keeps the dough from running away before it hits the fridge. Warm water is only for the same-day version.',
          'Balls hold 4–5 hours on the bench before over-proofing. Past that they go sticky and tear.',
          'Sizing rule: approximately 2.5 g of dough per square inch. A 14-inch pie wants ~385 g, a 10-inch wants ~195 g.',
          'Skip the olive oil entirely if you are baking Neapolitan-style in a high-heat outdoor oven. Keep it for home-oven and pan pizza.',
        ],
      },
      {
        title: 'Storage',
        steps: [
          'Freeze after balling: oil each ball, bag individually, up to 3 months.',
          'Thaw in the refrigerator overnight, then bench proof 3–4 hours as normal.',
        ],
      },
    ],
  },
  {
    id: 'taylors-parmesan',
    name: "Taylor's Parmesan",
    category: 'Sauces',
    baseYield: 4,
    defaultBase: 'Parmesan, grated',
    servingNote: 'Pour over thin-sliced seared steak. Makes enough for about 1 lb of steak.',
    images: ['/recipes/taylors-parmesan-cover.jpg'],
    ingredients: [
      { name: 'Butter', grams: 28, volumeUnit: 'tbsp', gramsPerUnit: 14 },
      { name: 'Flour', grams: 16, volumeUnit: 'tbsp', gramsPerUnit: 8 },
      { name: 'Water', grams: 118, volumeUnit: 'cups', gramsPerUnit: 237 },
      { name: 'Sour Cream', grams: 115, volumeUnit: 'cups', gramsPerUnit: 230 },
      { name: 'Salt', grams: 3, volumeUnit: 'tsp', gramsPerUnit: 6 },
      { name: 'Fish Sauce', grams: 0.7, volumeUnit: 'tsp', gramsPerUnit: 6, note: 'a drop' },
      { name: 'Parmesan, grated', grams: 60, volumeUnit: 'cups', gramsPerUnit: 80 },
      { name: 'White Cheddar, shredded', grams: 28, volumeUnit: 'cups', gramsPerUnit: 113 },
      { name: 'Accent (MSG)', grams: 2, volumeUnit: 'tsp', gramsPerUnit: 4 },
    ],
    instructions: [
      'Melt the butter in a pan over medium heat.',
      'Once the butter has melted, whisk in the flour and stir until it thickens into a paste.',
      'Add the water and whisk smooth. Do this before anything else goes in.',
      'Stir in the sour cream.',
      'Mix in the salt.',
      'Add the fish sauce.',
      'Stir in the Parmesan and white cheddar until melted and smooth.',
      'Mix in the Accent and serve hot.',
    ],
  },
  {
    id: 'taylors-vanity-cakes',
    name: "Taylor's Vanity Cakes",
    category: 'Desserts',
    baseYield: 6,
    defaultBase: 'White Flour',
    note: 'Fry in 1 to 2 lbs of lard (or vegetable oil), about 3 inches deep.',
    images: ['/recipes/taylors-vanity-cakes-cover.jpg'],
    ingredients: [
      { name: 'Large Egg', grams: 50, volumeUnit: 'large eggs', gramsPerUnit: 50, showEggCount: true },
      { name: 'Salt', grams: 0.4, volumeUnit: 'tsp', gramsPerUnit: 6, note: 'a pinch' },
      { name: 'White Flour', grams: 60, volumeUnit: 'cups', gramsPerUnit: 125, note: 'plus extra for flouring the board' },
      { name: 'Powdered Sugar', asNeeded: true, note: 'for dusting' },
    ],
    instructions: [
      'Heat the lard or oil in a deep pan or fryer to 350°F (175°C).',
      'Beat the egg and salt hard for a full minute.',
      'Beat in the flour about a tablespoon at a time until the batter is stiff and sticky: too thick to beat, too soft to roll.',
      "Flour a plate or cutting board generously. Drop the batter in six teaspoon-sized portions, then use a knife to turn each one so it's coated in flour.",
      'Drop each portion into the hot fat as a compact lump. Fry at least 3½ minutes, turning halfway, until puffed and light golden.',
      'Lift out with a slotted spoon, drain briefly on paper towels, and dust generously with powdered sugar while warm.',
    ],
  },
];

const categories = ['Mains', 'Grains', 'Sauces', 'Desserts', 'Seasonings', 'Charts'];

export { recipes, categories };
